import { render } from "./ViewTestReport.vue?vue&type=template&id=0623f432"
import script from "./ViewTestReport.vue?vue&type=script&lang=js"
export * from "./ViewTestReport.vue?vue&type=script&lang=js"

import "./ViewTestReport.vue?vue&type=style&index=0&id=0623f432&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ViewTestReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0623f432"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0623f432', __exports__)) {
    console.log('reload')
    api.reload('0623f432', __exports__)
  }
  
  module.hot.accept("./ViewTestReport.vue?vue&type=template&id=0623f432", () => {
    console.log('re-render')
    api.rerender('0623f432', render)
  })

}


export default __exports__